<div class="mark-tool-dark-theme internal anon-help mat-app-background">
    <mat-card>
        <mat-card-content>
            <help-center></help-center>
        </mat-card-content>
    </mat-card>
</div>
